import { useContext, useState } from "react"
import { BASE_URL } from "../../../services/configUrls";
import axios from "axios";
import { ArrowRightLeft } from 'lucide-react';
import { TextEditorContext } from "../../../context/TextEditorContext";
import { SelectedElementContex } from "../../../context/SelectedElement";


export default function ImagePreviewTextField ({ label, value, onHandleInputChange }) {
    const [ uploadOffline, setUploadOffline ] = useState(true);
    const { insertImageAtCursor } = useContext(TextEditorContext);
    const { selectedElement } = useContext(SelectedElementContex);

    const handleFileSelect = async (e) => {
        const file = e.target.files[0];
        if (!file) return;
    
        // Upload instantly
        const formData = new FormData();
        formData.append("file", file);
    
        try {
          const res = await axios.post(
            `${BASE_URL}/schedule_email/upload-image`,
            formData,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          );
    
          const url = res.data.image_url;
          if(url){
            insertImageAtCursor(url);
          }
        } catch (err) {
          alert(`Upload failed: ${err}`);
          console.log("Upload failed :"+err)
        }
      };

    return (
        <div>
            <label>Upload image</label>
            {/* <img src={value} alt="image" className="w-full h-[150px] object-cover border rounded-xl"/> */}
             <input type="file" accept="image/*" onMouseDown={(e) => e.preventDefault()} onChange={handleFileSelect} className="mt-2 border w-full h-7"/> 
        </div>
    )
}